// this file is automatically generated by git.version.ts script
export const versions = {version: '1.97.3', revision: 'dac1aac1', branch: 'development'};
